export function initBillingContactForm() : void {
    const $billingContactForms = document.querySelectorAll<HTMLFormElement>('.js-billing-contact-form');

    $billingContactForms.forEach($billingContactForm => {
        new BillingContactForm($billingContactForm);
    });
}

class BillingContactForm {
    $form: HTMLFormElement;
    $addressTypeRadios: NodeListOf<HTMLInputElement>;
    $addressInput: HTMLInputElement|null;
    $zipInput: HTMLInputElement|null;
    $townInput: HTMLInputElement|null;

    constructor($form: HTMLFormElement) {
        this.$form = $form;
        this.$addressTypeRadios = this.$form.querySelectorAll<HTMLInputElement>('input[name="form[address_type]"]');
        this.$addressInput = this.$form.querySelector<HTMLInputElement>('input[name="form[address]"]');
        this.$zipInput = this.$form.querySelector<HTMLInputElement>('input[name="form[zip]"]');
        this.$townInput = this.$form.querySelector<HTMLInputElement>('input[name="form[town]"]');

        this.addFormEvents();
    }

    /**
     * Add events on form fields
     * 
     * @return {void}
     */
    addFormEvents() : void {
        const changeAddressType = () => {
            this.changeAddressTypeHandler();
        };

        this.changeAddressTypeHandler();
        this.$addressTypeRadios.forEach($addressTypeRadio => {
            $addressTypeRadio.addEventListener('change', changeAddressType);
        });
    }

    /**
     * On change Address Type
     * 
     * @return {void}
     */
    changeAddressTypeHandler() : void {
        let addressType = false;

        this.$addressTypeRadios.forEach($addressTypeRadio => {
            if ($addressTypeRadio.checked) {
                addressType = 'yes' === $addressTypeRadio.value ? true : false;
            }
        });

        if (addressType) {
            if (this.$addressInput) {
                this.$addressInput.setAttribute('readonly', 'true');
                this.$addressInput.value = this.$addressInput.dataset.entityValue || '';
            }

            if (this.$zipInput) {
                this.$zipInput.setAttribute('readonly', 'true');
                this.$zipInput.value = this.$zipInput.dataset.entityValue || '';
            }

            if (this.$townInput) {
                this.$townInput.setAttribute('readonly', 'true');
                this.$townInput.value = this.$townInput.dataset.entityValue || '';
            }
        } else {
            this.$addressInput?.removeAttribute('readonly');
            this.$zipInput?.removeAttribute('readonly');
            this.$townInput?.removeAttribute('readonly');
        }
    }
}
